import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { PhysicalRiskApi } from "../../../api";

export const physicalRiskKeys = {
  suppliersList: () => ["suppliersList"],
  supplierPhysicalRisk: () => ["supplierPhysicalRisk"],
  supplierFinancialRisk: () => ["supplierFinancialRisk"]
};

export function usePhysicalRiskReport(params, config) {
  const { callApi } = useAuth();
  return useQuery(["physicalRisk", params.year, params.quarter],
    () => callApi(PhysicalRiskApi.getPhysicalRiskReport, params), config);
}

export function useExportSuppliersPhysicalRiskData(config) {
  const { callApi } = useAuth();
  return useMutation(({ params }) => callApi(PhysicalRiskApi.exportSuppliersPhysicalRiskData, params), config);
}

export function useGetPhysicalRiskSuppliersList(config) {
  const { callApi } = useAuth();
  return useQuery(physicalRiskKeys.suppliersList(),
    () => callApi(PhysicalRiskApi.getPhysicalRiskSuppliersList), config);
}

export function useGetSupplierPhysicalRisk(params, config) {
  const { callApi } = useAuth();
  return useQuery([...physicalRiskKeys.supplierPhysicalRisk(), params.scenario, params.supplierId],
    () => callApi(PhysicalRiskApi.getSupplierPhysicalRisk, params), config);
}

export function useGetSupplierFinancialRisk(params, config) {
  const { callApi } = useAuth();
  return useQuery([...physicalRiskKeys.supplierFinancialRisk(), params.scenario, params.supplierId],
    () => callApi(PhysicalRiskApi.getSupplierFinancialRisk, params), config);
}